import Vue from "vue";
import VueRouter from "vue-router";
import AppDetails from "../views/AppDetails.vue";
import Home from "../views/Home.vue";
import AppsList from "../views/AppsList";
import TemplatesList from "../views/TemplatesList";
import cssVars from "css-vars-ponyfill";
import services from "@/services";
import store from "@/store";
import {
  MUTATION_NAME,
  STUDIO_MESSAGES,
  VEEVA_MESSAGES,
  EXP_MESSAGES,
  DEPLOYMENTS_COLUMN_KEYS,
  HTML_REPORT_FIELD_NAMES,
  ROUTE_NAMES,
  PAGES_PATH
} from "@/static/global-variables";
import utils from "@/utils";
import i18n from "@/plugins/i18n";
import SfGlobalObjects from "@/utils/sf-global-objects";
Vue.use(VueRouter);

cssVars({});

const routes = [
  {
    path: "/",
    redirect: `/${PAGES_PATH.APPS}`
  },
  {
    path: `/studio/${PAGES_PATH.APPS}`,
    redirect: `/${PAGES_PATH.APPS}`
  },
  {
    path: `/${PAGES_PATH.APPS}`,
    component: Home,
    meta: {
      breadCrumb: "HOME"
    },
    beforeEnter: (to, from, next) => {
      services.getSession().then(
        resp => {
          if (resp.data.status === "SUCCESS") {
            // initialize elm compiler as soon as possible to set correct user locale
            services.initElmCompiler(resp.data.data.userLocale);
            store.commit(MUTATION_NAME.SET_HAS_SESSION, true);
            const respData = resp.data.data;
            const sfSession = respData.sfSession;
            const sfEndpoint = respData.sfEndpoint;
            const userLocale = respData.userLocale;
            const userTimeZone = respData.userTimeZone;

            i18n.locale = respData.userLanguage;

            Vue.$cookies
              .set("sfSession", sfSession)
              .set("sfEndpoint", sfEndpoint)
              .set("username", respData.username);

            store.commit(MUTATION_NAME.SET_DOMAIN, respData.domain);
            services.addDomainToUrl(respData.domain);

            const dataFetchingInfo = {
              isFailed: false
            };

            store.commit(MUTATION_NAME.SET_USERNAME, respData.username);

            store.commit(MUTATION_NAME.SET_USER_LOCALE, userLocale);
            store.commit(MUTATION_NAME.SET_USER_TIMEZONE, userTimeZone);

            services.setAPICommonHeaders(sfSession, sfEndpoint);
            services.instantiateSFClient(sfSession, sfEndpoint);

            services.getCustomSettings(sfEndpoint, sfSession).then(
              resp => {
                store.commit(MUTATION_NAME.SET_CRM_SERVER_URL, resp.crm.url);
                store.commit(
                  MUTATION_NAME.SET_CRM_SERVER_VERSION,
                  resp.crm.version
                );

                store.commit(MUTATION_NAME.SET_MC_SERVER_URL, resp.mc.url);
                store.commit(
                  MUTATION_NAME.SET_MC_SERVER_VERSION,
                  resp.mc.version
                );

                store.commit(MUTATION_NAME.SET_TERRITORY_SERVER_URL, resp.territory.url);
                store.commit(
                    MUTATION_NAME.SET_TERRITORY_SERVER_VERSION,
                    resp.territory.version
                );
              },
              error => {
                console.error(error);
                console.log(
                  "Failed to obtain crm url, Nitro query will not work."
                );
              }
            );

            services.describeObject("HTML_Report_vod__c").then(
              res => {
                const config = {
                  obj: "HTML_Report_vod__c",
                  data: res
                };

                store.commit(MUTATION_NAME.SET_OBJECT_DESCRIBE, config);

                let includeStudioVersion = res.fields.find(f => {
                  return (
                    f.name.toLowerCase() ===
                    HTML_REPORT_FIELD_NAMES.Studio_Version_vod__c.toLowerCase()
                  );
                });

                services
                  .fetchFieldLabelsForObject(
                    "HTML_Report_vod__c",
                    includeStudioVersion
                  )
                  .then(
                    resp => {
                      let fields = utils.getFormattedFieldNames(
                        resp.HTML_Report_vod__c,
                        DEPLOYMENTS_COLUMN_KEYS
                      );

                      store.commit(
                        MUTATION_NAME.SET_HTML_REPORT_FIELD_LABELS,
                        fields
                      );
                    },
                    err => {
                      console.error(err);
                    }
                  );
              },
              err => {
                console.error(err);
                console.log(
                  "Do not have access to find HTML_Report_vod__c Object"
                );
              }
            );

            const orgObj = {
              isSandbox: respData.sandbox,
              Name: respData.orgName,
              id: respData.orgId
            };

            store.commit(MUTATION_NAME.SET_ORG, orgObj);

            if (!store.getters.messages) {
              // Query parameters length in GET request is limited
              // Each request can have about 100 messages since the libray used to request those messages
              // appends other necessary param values to each messaage.
              // For example: DATA_EL_OBJECT_TRANSLATION will end up being:
              // (Name='DATA_EL_OBJECT_TRANSLATION' AND Category_vod__c='MI_STUDIO' AND Active_vod__c=true) OR
              const a = services.getMessages(
                respData.userLanguage,
                VEEVA_MESSAGES
              );
              const b = services.getMessages(
                respData.userLanguage,
                STUDIO_MESSAGES
              );
              const c = services.getMessages(
                respData.userLanguage,
                EXP_MESSAGES
              );

              Promise.all([a, b, c]).then(
                result => {
                  const allMessages = result.flat();
                  store.commit(
                    MUTATION_NAME.SET_MESSAGES,
                    utils.reformatMessages(
                      allMessages,
                      [...VEEVA_MESSAGES, ...STUDIO_MESSAGES, ...EXP_MESSAGES],
                      userLocale
                    )
                  );
                  to.params.dataFetchingInfo = dataFetchingInfo;
                },
                err => {
                  console.error("Veeva messages not loaded", err);
                }
              );
            }
            const userObj = {
              id: respData.userId,
              language: respData.userLanguage,
              sfdcUsername: respData.sfdcUsername
            };

            store.commit(MUTATION_NAME.SET_USER, userObj);

            services.fetchApps().then(
              resp => {
                const apps = services.mergeDirtyApps(resp);
                store.commit(MUTATION_NAME.SET_APPS, apps);
                next();
              },
              () => {
                console.log("Unable to retrieve content");
                store.commit(MUTATION_NAME.SET_APPS, []);
                dataFetchingInfo.isFailed = true;
                to.params.errorLoadingContent = true;
                next();
              }
            );
          } else {
            window.location.href = `${services.studioDomain}/login`;
          }
        },
        () => {
          window.location.href = `${services.studioDomain}/login`;
        }
      );
    },
    children: [
      {
        path: "",
        name: ROUTE_NAMES.appsList,
        component: AppsList
      },
      {
        path: "/templates",
        name: ROUTE_NAMES.templatesList,
        component: TemplatesList
      },
      {
        path: ":appId",
        name: "AppDetails",
        beforeEnter: (to, from, next) => {
          let localApps;
          let localApp;
          const data = {
            local: null,
            server: null,
            isDirty: false,
            errorLoadingLocal: null,
            fetchAppsFailed: null
          };

          function checkLocalSavedData() {
            try {
              localApps = services.getAppsFromLocal();
              localApp = localApps
                ? utils.findAppByAppId(localApps, to.params.appId)
                : null;
            } catch (error) {
              data.errorLoadingLocal = true;
            }
          }

          function setBridgeSetAppAndCompleteNavigation(app) {
            if (app) {
              const objInfo = utils.getBridgeObjectIds(
                app.type,
                store.getters.user.id,
                app.testRecord,
                app.contextAccount
              );
              services.instantiateBridge(objInfo);
              services.subscribeToIsDeployable();
              store.commit(MUTATION_NAME.UPDATE_APP, app);
            }
            store.commit(MUTATION_NAME.RESET_CHANNEL_PAGE_DATA);
            next();
          }

          let selectedApp;
          function fetchApp() {
            const appId = to.params.appId;
            const matchedAppOnServer = utils.findAppByAppId(
              store.getters.apps,
              appId
            );
            store.commit(MUTATION_NAME.SET_LATEST_APPS, { fetch: true });
            let params = { appId };
            if (matchedAppOnServer.isTemplate) {
              params.version = matchedAppOnServer.version;
            }

            function setContentAndBridge(app) {
              SfGlobalObjects.updateApp(
                app,
                SfGlobalObjects.updatePicklistFields
              ).then(() => {
                store.commit(MUTATION_NAME.SET_CURRENT_CONTENT, app);
                setBridgeSetAppAndCompleteNavigation(app);
              });
            }

            services
              .fetchSelectedApp(params)
              .then(
                resp => {
                  const isAppDirty = localApp ? localApp.isDirty : false;
                  if (isAppDirty) {
                    // prompt
                    utils.mergeMetadata(localApp, matchedAppOnServer);
                    data.local = localApp;
                    data.server = resp.json;
                    utils.mergeMetadata(data.server, matchedAppOnServer);
                    data.isDirty = true;
                    selectedApp = localApp;
                  } else {
                    // no local data is available, use remote data
                    resp.json.isDirty = false;
                    // update name and testRecord from the metadata API
                    // name and testRecord are only cached in the data json and
                    // are not auhoritative
                    resp.json.name = matchedAppOnServer.name;
                    resp.json.testRecord = matchedAppOnServer.testRecord;
                    selectedApp = resp.json;
                    utils.mergeMetadata(selectedApp, matchedAppOnServer);
                  }
                  if (selectedApp.isTemplate && matchedAppOnServer.version) {
                    selectedApp.version = resp.version;
                  }
                },
                err => {
                  // no version found, use the local app
                  console.error(err.response.data);
                  if (localApp) {
                    // no remote found, but local found
                    const apps = store.getters.apps;
                    const currentApp = utils.findAppByAppId(apps, appId);
                    localApp.isDirty = true;
                    utils.mergeMetadata(localApp, currentApp);
                    data.local = localApp;
                    data.server = {};
                    utils.mergeMetadata(data.server, currentApp);
                    data.isDirty = localApp.isDirty;
                    const n = currentApp.name;
                    const t = currentApp.testRecord;
                    localApp.name = n;
                    localApp.testRecord = t;
                    data.server.name = n;
                    data.server.testRecord = t;
                    selectedApp = localApp;
                  } else {
                    // no remote, no local, app should be an newly created app
                  }
                }
              )
              .finally(() => {
                const apps = store.getters.apps;
                const currentApp =
                  selectedApp || utils.findAppByAppId(apps, appId);
                const objName = utils.getObjectFromContentType(currentApp.type);

                to.params.isDataDirty = data.isDirty;
                to.params.dataInfo = data;
                store.commit(MUTATION_NAME.SET_LATEST_APPS, null);

                if (objName && currentApp && currentApp.testRecord) {
                  services
                    .fetchContentContextData(objName, currentApp.testRecord)
                    .then(
                      resp => {
                        const r = resp.records[0] || {};
                        currentApp.contextAccount =
                          objName === "Account" ? r.Id : r.Account_vod__c;
                        setContentAndBridge(currentApp);
                      },
                      err => {
                        console.error(err);
                        to.params.contextDataFailed = true;
                        setContentAndBridge(currentApp);
                      }
                    );
                } else {
                  setContentAndBridge(currentApp);
                }
              });
          }

          if (!store.getters.apps) {
            store.commit(MUTATION_NAME.SET_LATEST_APPS, { fetch: true });
            services
              .fetchApps()
              .then(
                resp => {
                  store.commit(MUTATION_NAME.SET_APPS, resp);
                },
                () => {
                  store.commit(MUTATION_NAME.SET_APPS, []);
                  data.fetchAppsFailed = true;
                }
              )
              .finally(() => {
                checkLocalSavedData();
                fetchApp();
              });
          } else {
            checkLocalSavedData();
            fetchApp();
          }
        },
        props: route => ({
          ...route.params
        }),
        component: AppDetails,
        children: [
          {
            path: "/",
            redirect: to => {
              const appId = to.params.appId;
              const appInStore = utils.findAppByAppId(
                store.getters.apps,
                appId
              );
              if (appInStore.customContent) {
                return "deploy";
              }
              return "data-palette";
            }
          },
          {
            path: "data-palette",
            name: "DataPalette",
            props: route => ({
              ...route.params
            }),
            // route level code-splitting
            // this generates a separate chunk (data-palette.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () =>
              import(
                /* webpackChunkName: "DataPalette" */ "../views/DataPalette.vue"
              )
          },
          {
            path: "pages",
            name: "Preview",
            props: route => ({
              ...route.params
            }),
            component: () =>
              import(/* webpackChunkName: "Pages" */ "../views/Pages.vue")
          },
          {
            path: "deploy",
            name: "Deploy",
            props: route => ({
              ...route.params
            }),
            component: () =>
              import(/* webpackChunkName: "Deploy" */ "../views/Deploy.vue")
          },
          {
            path: "settings",
            props: route => ({
              ...route.params
            }),
            component: () =>
              import(/* webpackChunkName: "Settings" */ "../views/Settings.vue")
          }
        ]
      },
      {
        path: `/${PAGES_PATH.DISTRIBUTION_CHANNELS}`,
        name: ROUTE_NAMES.distributionChannels,
        component: () =>
          import(
            /* webpackChunkName: "DistributionChannelsPage" */ "@/views/DistributionChannelsPage"
          )
      },
      {
        path: `/${PAGES_PATH.DISTRIBUTION_CHANNELS}/:uuid`,
        name: ROUTE_NAMES.distributionChannelDetails,
        redirect: { name: ROUTE_NAMES.distributionChannelOverview },
        component: () =>
          import(
            /* webpackChunkName: "DistributionChannelDetails" */ "@/components/custom-display-elements/distribution-channels/DistributionChannelDetails"
          ),

        children: [
          {
            path: "overview",
            name: ROUTE_NAMES.distributionChannelOverview,
            props: route => ({
              ...route.params
            }),
            component: () =>
              import(
                /* webpackChunkName: "DistributionChannelOverview" */ "@/components/custom-display-elements/tabs/Overview"
              )
          },
          {
            path: "custom-display-elements",
            name: ROUTE_NAMES.distributionChannelCustomDisplayElements,
            props: route => ({
              ...route.params
            }),
            component: () =>
              import(
                /* webpackChunkName: "DistributionChannelCustomDisplayElements" */ "@/components/custom-display-elements/tabs/CustomDisplayElements"
              ),
            children: [
              {
                path: ":widgetuuid",
                redirect: { name: ROUTE_NAMES.customDisplayElementDetails },
                props: route => ({
                  ...route.params
                })
              },
              {
                path: ":widgetuuid/details",
                name: ROUTE_NAMES.customDisplayElementDetails,
                props: route => ({
                  ...route.params
                }),
                component: () =>
                  import(
                    /* webpackChunkName: "DistributionChannelCustomDisplayElementDetails" */ "@/components/custom-display-elements/tabs/CustomDisplayElementDetails"
                  )
              },
              {
                path: ":widgetuuid/version",
                redirect: { name: ROUTE_NAMES.customDisplayElementDetails },
                props: route => ({
                  ...route.params
                })
              },
              {
                path: ":widgetuuid/version/:widgetversionuuid",
                redirect: {
                  name: ROUTE_NAMES.customDisplayElementVersionDetails
                },
                props: route => ({
                  ...route.params
                })
              },
              {
                path: ":widgetuuid/version/:widgetversionuuid/details",
                name: ROUTE_NAMES.customDisplayElementVersionDetails,
                props: route => ({
                  ...route.params
                }),
                component: () =>
                  import(
                    /* webpackChunkName: "DistributionChannelCustomDisplayElementVersionDetails" */ "@/components/custom-display-elements/tabs/CustomDisplayElementVersionDetails"
                  )
              }
            ]
          },
          {
            path: "customer-domains",
            name: ROUTE_NAMES.distributionChannelCustomerDomains,
            props: route => ({
              ...route.params
            }),
            component: () =>
              import(
                /* webpackChunkName: "DistributionChannelCustomerDomains" */ "@/components/custom-display-elements/tabs/CustomerDomains"
              )
          }
        ]
      }
    ]
  }
];

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes
});

export default router;
